import { SubLocation } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;

export const SubLocationService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getSubLocations = async (locationIds: string[], subLocationId?: string): Promise<SubLocation[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<SubLocation[]>('GetCascadingAsync', locationIds, subLocationId);
    } else {
      throw 'SubLocation DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getSubLocations,
  };
})();
